// extracted by mini-css-extract-plugin
export var cartContainer = "_mk-4";
export var gray = "_mk-1";
export var itemContainer = "_mk-2";
export var itemDetails = "_mk-3";
export var strong = "_mk-0";